import { historyQueryTime } from "./dateTime.js";

export const LIVE_EXPORT_GRACE_MS = 2 * 60 * 1000;

export function liveExportRange(nowMs, windowMinutes, graceMs = LIVE_EXPORT_GRACE_MS) {
    const minutes = Number(windowMinutes);
    const span = (Number.isFinite(minutes) && minutes > 0 ? minutes : 60) * 60 * 1000;
    return {
        startMs: nowMs - span,
        endMs: nowMs + graceMs,
    };
}

export function historyExportRequest({
    charts,
    mode,
    startTime,
    endTime,
    nowMs,
    liveWindowMinutes,
    timeZone,
}) {
    const tagIds = [];
    const seen = new Set();
    (Array.isArray(charts) ? charts : []).forEach((chart) => {
        const id = Number(chart?.tagId);
        if (!Number.isInteger(id) || id <= 0 || seen.has(id)) {
            return;
        }
        seen.add(id);
        tagIds.push(id);
    });
    if (tagIds.length === 0) {
        return { ok: false, error: "Select at least one tag." };
    }
    if (mode === "live") {
        const range = liveExportRange(nowMs, liveWindowMinutes);
        return {
            ok: true,
            body: {
                tag_ids: tagIds,
                start_time: new Date(range.startMs).toISOString(),
                end_time: new Date(range.endMs).toISOString(),
                time_zone: timeZone || "",
                mode: "live",
            },
        };
    }
    const start = historyQueryTime(startTime, "start", timeZone);
    const end = historyQueryTime(endTime, "end", timeZone);
    if (!start || !end) {
        return { ok: false, error: "The selected time range could not be converted." };
    }
    if (Date.parse(start) >= Date.parse(end)) {
        return { ok: false, error: "Start time must be earlier than end time." };
    }
    return {
        ok: true,
        body: {
            tag_ids: tagIds,
            start_time: start,
            end_time: end,
            time_zone: timeZone || "",
            mode: "range",
        },
    };
}

export function acceptExportResponse(headers) {
    const source = headers || {};
    const complete = String(source["x-aqueris-export-complete"] || "").toLowerCase();
    if (complete !== "true") {
        return {
            ok: false,
            error: "The export did not confirm that every persisted record was included.",
        };
    }
    return {
        ok: true,
        rows: Number(source["x-aqueris-export-rows"] || 0),
        sheets: Number(source["x-aqueris-export-sheets"] || 0),
        split: String(source["x-aqueris-export-split"] || "") === "true",
    };
}

export function describeExportFailure(status, detail) {
    const message = typeof detail === "string" && detail.trim() ? detail.trim() : "";
    if (status === 401 || status === 403) {
        return message || "Authentication or permission error. Sign in again and retry the export.";
    }
    if (status === 404) {
        return "Export endpoint unavailable.";
    }
    if (status === 400) {
        return message || "Invalid date range or tag selection.";
    }
    if (status >= 500) {
        return message || "Server failed while generating Excel.";
    }
    return message || "The history export failed.";
}

export function clearCursorState(state) {
    return {
        ...state,
        selection: null,
    };
}
